export default "__VITE_ASSET__CHOXhYFe__";